import { loadStripe } from '@stripe/stripe-js';

// This is your test publishable API key.
// Replace with your actual publishable key
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Only initialize Stripe if we have a valid key
const stripePromise = publishableKey && publishableKey !== 'pk_test_your_publishable_key_here' 
  ? loadStripe(publishableKey)
  : null;

export default stripePromise; 